import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/faturamento/reguascobrancas/v1`;

const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function createReguaCobranca({ empresa_cnpj, body }) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);
}

export const getReguaCobrancaByEmpresaId = async ({
  empresa_id,
  empresa_cnpj,
}) =>
  search(
    `${path}?empresa_cnpj=${empresa_cnpj}&where[empresa_id]=${empresa_id}`,
    "GET",
    headers
  );
